/**
 * Created by mac on 7/8/18
 * @return {boolean}
 */

const LoginButton = cleverapps.UI.Button.extend({
    ctor: function (options) {
        options = options || {};
        this.options = options;

        this.options.onSuccess = options.onSuccess || function () {};
        this.options.onFailure = options.onFailure || function () {};

        this.source = options.source || connector.info.source;

        const styles = cleverapps.styles.LoginButton;
        const settings = {
            type: options.type,
            width: options.width || styles.width,
            height: options.height || styles.height,
            onClicked: this.onClicked.bind(this),
            content: options.content,
            text: !options.content ? this.getText() : undefined,
            icons: {
                "%%": LoginButton.getIcon(this.source)
            }
        };

        const isCustom = styles.content[this.source] !== undefined;
        if (isCustom) {
            settings.height = styles.customHeight;
            settings.content = this.getContent();
            settings.text = undefined;
            settings.icons = undefined;
            settings.type = {
                button_png: bundles.buttons.frames.sign_in_button_png,
                button_on_png: bundles.buttons.frames.sign_in_button_on_png,
                button_off_png: bundles.buttons.frames.sign_in_button_png,
                keepRadius: false
            };
        }

        this._super(settings);
    },

    getContent: function () {
        return new cc.Sprite(cleverapps.styles.LoginButton.content[this.source]);
    },

    getText: function () {
        return (LoginButton.getIcon(this.source, this.defaultIcon) ? "%% " : "") + (Messages.get(this.options.text || "SignIn"));
    },

    onClicked: function () {
        if (!connector.social.isConnected()) {
            cleverapps.notification.create(Messages.get("SocialManager.Initialization"));
            return;
        }

        this.disable();

        const callback = function () {
            cleverapps.SocialManager.login((success) => {
                if (success) {
                    this.options.onSuccess();
                } else {
                    this.options.onFailure();

                    cleverapps.SocialManager.onFailedLogin(); 
                }

                this.enable();
            }, {
                source: this.source
            });
        }.bind(this);

        if (this.options.multiSocials && connector.info.isNative) {
            this.stopAllActions();
            this.setScale(0.95);
            this.runAction(new cc.Sequence(
                new cc.DelayTime(0.05),
                new cc.CallFunc(callback),
                new cc.ScaleTo(0.15, 1).easing(cc.easeBackInOut())
            ));
        } else {
            callback();
        }
    }
});

LoginButton.getIcon = function (source) {
    return cleverapps.styles.LoginButton.icon.image[source];
};

cleverapps.styles.LoginButton = {
    width: 200,
    height: 110,

    icon: {
        image: {
            ok: bundles.socialicons.frames.login_ok_icon_png,
            vk: bundles.socialicons.frames.login_vk_icon_png,
            mbga: bundles.socialicons.frames.login_mobage_icon_png,
            sp_mbga: bundles.socialicons.frames.login_mobage_icon_png,
            draugiem: bundles.socialicons.frames.login_draugiem_icon_png,
            mm: bundles.socialicons.frames.login_mm_icon_png,
            fotostrana: bundles.socialicons.frames.login_fs_icon_png,
            plinga: bundles.socialicons.frames.login_plinga_icon_png,
            kongregate: bundles.socialicons.frames.login_kongregate_icon_png
        }
    },

    customHeight: 100,
    content: {
        "facebook": bundles.social_buttons.frames.sign_in_facebook,
        "microsoft": bundles.social_buttons.frames.sign_in_facebook,
        "android": bundles.social_buttons.frames.sign_in_google,
        "apple": bundles.social_buttons.frames.sign_in_apple
    }
};
